import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslations } from "../../hooks/use-translations";
import _ from "lodash";
import { useLanguage } from "../../hooks/use-language";

const Container = ({ children }) => {
	const lang = useLanguage();
	const textosClub = useTranslations({ section: "comunidad_club", lang: lang });

	const iconSize = 30;
	return (
		<nav aria-label={_.get(textosClub, 'nav.aria_label') || "Navegación de comunidad"} className="community-nav container d-flex flex-column-reverse flex-lg-row justify-content-between py-2">
			<ul className="d-none d-md-flex flex-column flex-sm-row justify-content-center align-items-center mt-2 mt-sm-0">
				{children}
			</ul>

			<ul className="d-flex  justify-content-center align-items-center p-0 my-2">
				<li>
					<a
						className="link focusable-secondary mr-3"
						aria-label={`${_.get(textosClub, 'nav.aria_open_link') || "Abrir en nueva pestaña"} WhatsApp`}
						href="https://chat.whatsapp.com/BFdd39DjpHPJYN5BxmUzWh"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Icon
							className="social-media-button whastapp"
							icon="ic:baseline-whatsapp"
							width={iconSize}
						/>
						<span className="sr-only">WhatsApp</span>
					</a>
				</li>
				<li>
					<a
						className="link focusable-secondary mr-3"
						aria-label={`${_.get(textosClub, 'nav.aria_open_link') || "Abrir en nueva pestaña"} Facebook`}
						href="https://www.facebook.com/Bookmakemake/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Icon
							className="social-media-button facebook"
							icon="ic:baseline-facebook"
							width={iconSize}
						/>
						<span className="sr-only">Facebook</span>
					</a>
				</li>
				<li>
					<a
						className="link focusable-secondary mr-3"
						aria-label={`${_.get(textosClub, 'nav.aria_open_link') || "Abrir en nueva pestaña"} Instagram`}
						href="https://www.instagram.com/makemakelibros"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Icon
							className="social-media-button instagram"
							icon="mdi:instagram"
							width={iconSize}
						/>
						<span className="sr-only">Instagram</span>
					</a>
				</li>
				<li>
					<a
						className="link focusable-secondary mr-3"
						aria-label={`${_.get(textosClub, 'nav.aria_open_link') || "Abrir en nueva pestaña"} Youtube`}
						href="https://www.youtube.com/channel/UCAGRlTJB3fUDRfkVRPVNdzQ"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Icon
							className="social-media-button youtube"
							icon="bi:youtube"
							width={iconSize}
						/>
						<span className="sr-only">Youtube</span>
					</a>
				</li>
				<li>
					<Link
						className="link underline focusable-secondary mr-3"
						aria-label={`${_.get(textosClub, 'nav.aria_open_link') || "Abrir en nueva pestaña"} ${_.get(textosClub, 'nav.item.boletin') || 'Boletín'}`}
						to={"/boletin/ingresar-datos"}
					>
						{_.get(textosClub, 'nav.item.boletin') || 'Boletín'}
					</Link>
				</li>
			</ul>
		</nav>
	);
};

const Item = ({ title, onClick, active }) => {
	return (
		<li>
			<button
				className={`focusable-secondary ${active?"active":""} p-2 mr-4 item secondary-font text-16`}
				onClick={() => onClick && onClick()}
				aria-pressed={active}
			>
				{title}
			</button>
		</li>
	);
};

export const CommunityNav = {
	Container,
	Item,
};
